import {Nullable, NullableKeys, TimeInputValue} from '@fl/cmsch-fe-library';

import {CreateMilkability} from 'api/gen/CreateMilkability';

/** Redux-form identifier for the milkability report form. */
export const milkabilityReportFormName = 'milkabilityReport';

/** Public form value shape for creating or editing a milkability report. */
export interface MilkabilityFormValues extends Omit<NullableKeys<CreateMilkability>, 'milkingTime'> {
    /** Calculated APMV value shown alongside the editable report fields. */
    apmv: Nullable<number>;
    /** Time-input value object used by the shared milking-time field. */
    milkingTime: Nullable<TimeInputValue>;
}

/** Default form values for a new milkability report session. */
export const initialMilkabilityFormValues: MilkabilityFormValues = {
    apmv: null,
    earTag: null,
    examinationDate: null,
    milkedTotal: null,
    milkingTime: null,
    technicianNumber: null,
};
